import { useRef } from "react";
import useOutsideBounds from "../services/useOutsideBounds";
import useSwipe from "../services/useSwipe";
import { GenerationInterface } from "../layout/generate";

interface Props {
  outsideClicked: () => void;
  selectedGeneration: GenerationInterface | null;
  previousGenerations: GenerationInterface[];
  onGenerationClick: (generation: GenerationInterface) => void;
}

export default function GenerateSidebar({ outsideClicked, selectedGeneration, previousGenerations, onGenerationClick }: Props) {
  const wrapperRef = useRef(null);
  
  useSwipe({
    threshold: 150,
    direction: "left",
    touchStart: () => {},
    touchMove: () => {},
    touchEnd: () => {},
    thresholdMet: outsideClicked,
  });

  useOutsideBounds(wrapperRef, outsideClicked);

  return (
    <aside
      ref={wrapperRef}
      className="custom-scrollbar fixed z-20 flex h-full w-10/12 max-w-sm flex-col justify-between gap-sm overflow-y-auto bg-slate-500 px-md py-lg xl:static"
    >
      <div className="space-y-sm">
        <div className="px-md py-sm">
          <h2 className="font-semibold text-slate-100">History</h2>
        </div>
        {previousGenerations.length > 0 ? (
          previousGenerations.map((generation, index) => (
            <div
              key={generation.id}
              className={`block truncate rounded-md px-md py-sm cursor-pointer ${
                selectedGeneration?.id === generation.id
                  ? "bg-slate-400 hover:bg-slate-300"
                  : "text-slate-100 hover:bg-slate-400"
              }`}
              onClick={() => onGenerationClick(generation)}
            >
              #{previousGenerations.length - index} - {generation.positive_prompt}
            </div>
          ))
        ) : (
          <div className="px-md py-sm">
            <small className="text-slate-100">No previous generations</small>
          </div>
        )}
      </div>
    </aside>
  );
}
